import { IndustryHero } from "./components/IndustryHero/IndustryHero";
import { TextSection } from "./components/TextSection/TextSection";
import { IndustryMetrics } from "./components/IndustryMetrics/IndustryMetrics";
import { CaseStudySection } from "./components/IndustryMetrics/CaseStudySection";
import { IndustryRecipes } from "./components/IndustryRecipes/IndustryRecipes";
import { DataProviders } from "../components/sections/DataProviders";
import { Solutions } from "../components/sections/Solutions";
import { Testimonial } from "../components/sections/Testimonial";
import { GetStartedNew } from "../components/sections/GetStartedNew";
import { Highlights } from "../components/sections/Highlights";

import data from "../../datasets/industryPages";

export const FinancialServices = () => {
  return (
    <>
      <IndustryHero
        title={data.hero.financialServices.title}
        description={data.hero.financialServices.description}
        images={data.hero.financialServices.images}
      />
      <TextSection textData={data.textSection.financialServices} />
      <IndustryMetrics metrics={data.metrics.financialServices}>
        <CaseStudySection />
      </IndustryMetrics>
      <IndustryRecipes recipes={data.recipes.financialServices} />
      <DataProviders providers={data.dataProviders.financialServices} />
      <Solutions />
      <Testimonial />
      <GetStartedNew />
      <Highlights />
    </>
  );
};
